import type { ReactNode } from 'react'

import { useDisabled, type DisabledState } from './disabled.tsx'

import './badge.css'

/**
 * 필터 알약 — 와이어프레임 `.rolepill` CSS 477행. 목록 툴바의 「역할 전체 ▾」 같은 것.
 *
 * 켜짐은 `aria-pressed` 로 나간다 — 색만으로 구분하지 않는다.
 * 권한이 없어도 숨기지 않고 비활성 + 사유다(§5-6).
 */
export type FilterPillProps = {
  children: ReactNode
  /** 켜짐 상태 */
  selected?: boolean | undefined
  onClick?: (() => void) | undefined
} & DisabledState

export function FilterPill({
  children,
  selected,
  onClick,
  disabled,
  disabledReason,
}: FilterPillProps) {
  const { isDisabled, ariaProps, reasonNode } = useDisabled(disabled, disabledReason)

  return (
    <button
      aria-pressed={selected}
      className="a-pill"
      onClick={isDisabled ? undefined : onClick}
      type="button"
      {...ariaProps}
    >
      {children}
      {reasonNode}
    </button>
  )
}
